import React from 'react';
import { Pagination as RDCPagination } from '@uncinc/uncinc-react-kitchen-sink';
import { usePagination } from 'react-instantsearch-core';
import './style.scss';
const SearchPagination = props => {
  const {
    previousLabel,
    nextLabel
  } = props;
  const pagination = usePagination();
  return /*#__PURE__*/React.createElement(RDCPagination, {
    currentPage: pagination.currentRefinement + 1,
    totalPages: pagination.nbPages,
    setCurrentPage: page => pagination.refine(page - 1),
    previousLabel: previousLabel,
    nextLabel: nextLabel,
    controlled: true
  });
};
export default SearchPagination;